export default "__VITE_ASSET__G$HUkv7i__"